/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemImage_item$ref: FragmentReference;
export type CartItemImage_item = {|
  +firstPhotoWebPath: ?string,
  +pdpURL: ?string,
  +title: ?string,
  +$refType: CartItemImage_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemImage_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "large",
          "type": "ImageVersionTypeName!"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"large\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd8e0cce9a8d4f4a9d0906c11cbd4ea56';
module.exports = node;
